import getHelper from '../../../services/getHelper';
import type { Talent } from '../../../../../index';

export default getHelper<Talent>('/talents/:id', {});
